import {
  Row,
  Divider,
} from "antd";
import get from "lodash/get";
import round from "lodash/round"
import GraphGrid from "../graphGrid";
import { getTransformedMinutes } from "../../../utilities/helpers";

const PunchPressContent = ({selectedTemplate, filter,data}) => {
  return (
       <Row id="content-container ">
        <GraphGrid
          graphId={1}
          type="day"
          stats={get(data, "on_off_graph", [])}
          label={"On / Off / Idle"}
          statistics={[
            {
              value: getTransformedMinutes(
                get(selectedTemplate, "meta.total_off_hours", 0)?round(get(selectedTemplate, "meta.total_off_hours", 0)):0
              ),
              // value:get(selectedTemplate, "meta.total_off_hours"),
              label: "Off Hours",
            },
            {
              value: getTransformedMinutes(
                get(selectedTemplate, "meta.total_idle_hours", 0)?round(get(selectedTemplate, "meta.total_idle_hours", 0)):0
              ),
              label: "Idle  Hours",
            },
            {
              value: getTransformedMinutes(
                get(selectedTemplate, "meta.total_working_hours", 0)?round(get(selectedTemplate, "meta.total_working_hours", 0)):0
              ),
              label: "Working Hours",
            },
          ]}
                selectedTemplate={selectedTemplate}
           filter={filter}
        />
        <Divider />
        <GraphGrid
          graphId={2}
          type="day"
          label={"counts"}
          stats={get(data, "count_graph", [])}
          statistics={[
            {
              value: get(selectedTemplate, "meta.total_count", 0)?round(get(selectedTemplate, "meta.total_count", 0)):0,
              label: "Counts",
            },
          ]}
                selectedTemplate={selectedTemplate}
           filter={filter}
        />
        <Divider />
        {get(data, "power_consumption_graph") && (
          <GraphGrid
            type="day"
            graphId={3}
            label={"Power Consumption"}
            stats={get(data, "power_consumption_graph", [])}
            statistics={[
              {
                value: `${get(
                  selectedTemplate,
                  "meta.total_power_consumption",
                  0
                )?round(get(
                  selectedTemplate,
                  "meta.total_power_consumption",
                  0
                )):0} Kwh`,
                label: "Power Consumption",
              },
            ]}
                  selectedTemplate={selectedTemplate}
           filter={filter}
          />
        )}
      </Row>
  )
}

export default PunchPressContent